import { render, staticRenderFns } from "./Actividades.vue?vue&type=template&id=31612010&"
import script from "./Actividades.vue?vue&type=script&lang=ts&"
export * from "./Actividades.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports